import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AsSeenInTrustedBy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const logos = [{
    name: "CREST Certified",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604898/img/logo_crest.png"
  }, {
    name: "Chainalysis",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604898/img/logo_chainalysis.png"
  }, {
    name: "CipherTrace",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604898/img/logo_ciphertrace.png"
  }, {
    name: "TRM Labs",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604898/img/logo_trm.png"
  }];
  return <section data-section-id="67807" id="industry-trust-signals" ref={ref} className={cn("relative overflow-hidden py-16 dark bg-background/80 backdrop-blur-sm border-y border-white/5 w-full transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      {}
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-r from-transparent via-primary/5 to-transparent -translate-x-full animate-[shimmer_5s_infinite]" />
      
      <div className="max-w-7xl mx-auto px-8">
        <p className="text-center text-muted-foreground text-xs font-mono tracking-[0.3em] uppercase mb-10">
          Verified by Global Blockchain Security & Forensic Standards
        </p>

        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
          {logos.map((logo, i) => <div key={i} data-index={i} className="group flex justify-center">
              <img src={logo.src} alt={`${logo.name} logo`} className="h-8 md:h-10 w-auto object-contain grayscale opacity-30 transition-all duration-500 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110 group-hover:drop-shadow-[0_0_15px_rgba(0,255,255,0.4)]" />
            </div>)}
        </div>
      </div>
    </section>;
}